<section class="dept dept-container" aria-label="Customer heading">
  <p class="customer-heading" data-testid="customer-heading">{{ user.customer_name }}</p>
</section>
